/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    asset: "A - TÀI SẢN NGẮN HẠN (100 = 110 + 120 + 130 + 140 + 150)",
    number: 100,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 1,
    asset: "I. Tiền và các khoản tương đương tiền",
    number: 110,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 2,
    asset: "II. Các khoản đầu tư tài chính ngắn hạn",
    number: 120,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 3,
    asset: "III. Các khoản phải thu ngắn hạn ",
    number: 130,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 4,
    asset: "IV. Hàng tồn kho ",
    number: 140,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 5,
    asset: "V. Tài sản ngắn hạn khác ",
    number: 150,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 6,
    asset: "B - TÀI SẢN DÀI HẠN (200 = 210 + 220 + 240 + 250 + 260)",
    number: 200,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 7,
    asset: "I. Các khoản phải thu dài hạn ",
    number: 210,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 8,
    asset: "II. Tài sản cố định  ",
    number: 220,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 9,
    asset: "III. Bất động sản đầu tư",
    number: 240,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 10,
    asset: "IV. Các khoản đầu tư tài chính dài hạn",
    number: 250,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 11,
    asset: "V. Tài sản dài hạn khác",
    number: 260,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 12,
    asset: "TỔNG CỘNG TÀI SẢN (270 = 100 + 200)",
    number: 270,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 13,
    asset: "NGUỒN VỐN",
    number: "",
    readOnly: true,
    value: { present: "", end: "", start: "" },
  },
  {
    id: 14,
    asset: "A - NỢ PHẢI TRẢ (300 = 310 + 330)",
    number: 300,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 15,
    asset: "I. Nợ ngắn hạn",
    number: 310,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 16,
    asset: "II. Nợ dài hạn",
    number: 330,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 17,
    asset: "B - VỐN CHỦ SỞ HỮU (400 = 410 + 430)",
    number: 400,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 18,
    asset: "I. Vốn chủ sở hữu",
    number: 410,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 19,
    asset: "II. Nguồn kinh phí và quỹ khác ",
    number: "430",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 20,
    asset: "TỔNG CỘNG NGUỒN VỐN (440 = 300 + 400)",
    number: "440",
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic" fontWeight="bold">
          Đơn vị tính: VND
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>TÀI SẢN</Th>
              <Th style={{ textAlign: "center" }}>Mã số</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Số cuối năm</Th>
              <Th style={{ textAlign: "center" }}>Số đầu năm</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>1</Th>
              <Th style={{ textAlign: "center" }}>2</Th>
              <Th style={{ textAlign: "center" }}>3</Th>
              <Th style={{ textAlign: "center" }}>4</Th>
              <Th style={{ textAlign: "center" }}>5</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    {rows.number}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      value={rows.value.present}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="end"
                      readOnly={rows.readOnly}
                      value={rows.value.end}
                      onChange={handleChange}
                      fontWeight={rows.readOnly}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="start"
                      readOnly={rows.readOnly}
                      value={rows.value.start}
                      onChange={handleChange}
                      fontWeight={rows.readOnly}
                    />
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function InputTable2(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
